export const parseDate = (str: string): Date => {
  // Convert DD.MM.YYYY HH:mm:ss → YYYY-MM-DDTHH:mm:ss
  const [date, time] = str.split(" ");
  const [day, month, year] = date.split(".");
  const [hour, min, sec] = time.split(":");
  let dateString = `${year}-${month}-${day}T${hour?.padStart(2, '0') || "00"}:${min?.padStart(2, '0') || "00"}:${sec?.padStart(2, '0') || "00"}`;
  let result = new Date(dateString);
  return result;
};

export const parsePairDate = (str: string): [Date, Date] => {
  // Convert DD.MM.YYYY HH:mm:ss → YYYY-MM-DDTHH:mm:ss
  const [date, date2] = str.split("-");
  const [day, month, year] = date.split(".");
  const [day2, month2, year2] = date2.split(":");
  let dateString = `${year}-${month}-${day}T00:00:00`;
  let date2String = `${year2}-${month2}-${day2}T23:59:59`;
  let result = new Date(dateString);
  let result2 = new Date(date2String);
  return [result, result2];
};

